<template>
  <div class="header">
    <el-menu
      :default-active="activeIndex"
      class="menu"
      mode="horizontal"
      router
      background-color="#E0EAF4"
      text-color="#2C3E50"
      active-text-color="#1976D2">
      <router-link to="/" class="logo-container">
        <img src="@/assets/logo.png" alt="臻晅科技" class="logo">
      </router-link>
      <div class="flex-grow"></div>
      <el-menu-item index="/">首页</el-menu-item>
      <el-submenu index="bureau">
        <template slot="title">教育局数据赋能</template>
        <!-- 财务管理分组 -->
        <el-menu-item index="/products?category=finance" @click="navigateTo('/products?tab=bureau&category=finance')">财务管理</el-menu-item>
        <!-- 人事管理分组 -->
        <el-menu-item index="/products?category=hr" @click="navigateTo('/products?tab=bureau&category=hr')">人事管理</el-menu-item>
        <!-- 学生服务分组 -->
        <el-menu-item index="/products?category=student" @click="navigateTo('/products?tab=bureau&category=student')">学生服务</el-menu-item>
        <!-- 办公管理分组 -->
        <el-menu-item index="/products?category=office" @click="navigateTo('/products?tab=bureau&category=office')">办公管理</el-menu-item>
        <!-- 资源管理分组 -->
        <el-menu-item index="/products?category=resource" @click="navigateTo('/products?tab=bureau&category=resource')">资源管理</el-menu-item>
        <!-- 数据分析分组 -->
        <el-menu-item index="/products?category=data" @click="navigateTo('/products?tab=bureau&category=data')">数据分析</el-menu-item>
        <el-menu-item index="/products?tab=bureau" @click="navigateTo('/products?tab=bureau')">查看全部</el-menu-item>
      </el-submenu>
      <el-submenu index="school">
        <template slot="title">智慧校园解决方案</template>
        <!-- 教师管理分组 -->
        <el-menu-item index="/products?category=teacher" @click="navigateTo('/products?tab=school&category=teacher')">教师管理</el-menu-item>
        <!-- 学生管理分组 -->
        <el-menu-item index="/products?category=school-student" @click="navigateTo('/products?tab=school&category=school-student')">学生管理</el-menu-item>
        <!-- 教学管理分组 -->
        <el-menu-item index="/products?category=teaching" @click="navigateTo('/products?tab=school&category=teaching')">教学管理</el-menu-item>
        <!-- 校园服务分组 -->
        <el-menu-item index="/products?category=service" @click="navigateTo('/products?tab=school&category=service')">校园服务</el-menu-item>
        <!-- 行政管理分组 -->
        <el-menu-item index="/products?category=admin" @click="navigateTo('/products?tab=school&category=admin')">行政管理</el-menu-item>
        <el-menu-item index="/products?tab=school" @click="navigateTo('/products?tab=school')">查看全部</el-menu-item>
      </el-submenu>
      <el-menu-item index="" @click="goToWeixiao">微校产品</el-menu-item>
      <el-menu-item index="/about">关于我们</el-menu-item>
      <el-menu-item index="/contact">联系我们</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      activeIndex: this.$route.path
    }
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.path
    }
  },
  methods: {
    goToWeixiao() {
      window.location.href = '/WeSchoolProducts/index.html'
    },
    navigateTo(path) {
      // 始终使用replace方法进行导航，避免创建过多的历史记录
      // 无论是否是相同路径，都执行路由跳转，确保查询参数的变化能够被处理
      this.$router.replace(path);
    }
  }
}
</script>

<style scoped>
.header {
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #E0EAF4;
}
.menu {
  display: flex;
  align-items: center;
}
.logo-container {
  display: flex;
  align-items: center;
  padding: 0 15px;
  height: 60px;
  text-decoration: none;
}
.text-logo {
  font-size: 1.5rem;
  font-weight: bold;
  color: #1976D2;
  background: linear-gradient(90deg, #1976D2, #64B5F6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 1px;
}
.logo {
  height: 26px;
  margin: 0;
  vertical-align: middle;
  max-width: 100%;
  object-fit: contain;
}
.flex-grow {
  flex-grow: 1;
}

/* 添加子菜单样式优化 */
.el-submenu .el-submenu__title {
  padding: 0 15px;
  font-weight: 500;
}

.el-menu--horizontal .el-menu .el-menu-item {
  padding: 0 15px;
  height: 36px;
  line-height: 36px;
}

/* 优化嵌套子菜单的样式 */
.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  margin-top: -3px;
}
</style>
